//

import { normalize } from 'normalizr';

import { simplApi } from '../../api/simplApi';
import { notification } from './schemas';

import { receiveStaff } from './staff';
import handleApiError from '../../helpers/handleApiError';
import { fetchTask } from './task';

const _ = require('lodash');

// ------------------------------------
// Constants
// ------------------------------------
export const REQUEST_NOTIFICATION = 'REQUEST_NOTIFICATION';
export const RECEIVE_NOTIFICATION = 'RECEIVE_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';

// ------------------------------------
// Actions
// ------------------------------------

export function requestNotification() {
  return {
    type: REQUEST_NOTIFICATION,
  };
}

export function receiveNotification(notifications) {
  return {
    type: RECEIVE_NOTIFICATION,
    payload: {
      notifications,
    },
  };
}

export const fetchNotification = notificationId => dispatch => {
  dispatch(requestNotification());

  const url =
    typeof notificationId !== 'undefined' && notificationId !== null
      ? `notifications/${notificationId}`
      : 'notifications';

  return simplApi(url)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        dispatch(handleApiError(json));
      } else {
        let preparedNotifications;

        if (typeof json.notifications !== 'undefined') {
          preparedNotifications = normalize(json, {
            notifications: [notification],
          });
        } else {
          preparedNotifications = normalize(json, {
            notification,
          });
        }

        const unreadNotifications = _.filter(
          preparedNotifications.entities.notifications,
          o => o.read_at === null,
        );

        unreadNotifications.forEach(el => {
          if (el.data.resource_type === 'App\\Task') {
            // dispatch(fetchTask(el.data.resource_id));
          }
        });

        dispatch(
          receiveNotification(preparedNotifications.entities.notifications),
        );
        dispatch(receiveStaff(preparedNotifications.entities.staffs));
      }
    });
};

export const markNotificationAsRead = notificationId => dispatch => {
  const url = 'notifications/read';
  const options = { method: 'post', body: { id: notificationId } };

  simplApi(url, options).then(() => {
    dispatch(fetchNotification());
  });
};

export const markAllNotificationsAsRead = () => dispatch => {
  const url = 'notifications/all/read';
  const options = { method: 'post' };

  simplApi(url, options).then(() => {
    dispatch(fetchNotification());
  });
};

export function removeNotification(notificationId) {
  return {
    type: REMOVE_NOTIFICATION,
    payload: notificationId,
  };
}

export const deleteNotification = notificationId => dispatch => {
  const url = `notifications/${notificationId}`;
  const options = { method: 'delete' };

  return simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        dispatch(handleApiError(json));
      } else {
        dispatch(removeNotification(notificationId));
      }
    });
};

export const saveNotification = newNotification => dispatch => {
  dispatch(requestNotification());

  let url = 'notifications/';
  const options = { method: 'post', body: newNotification };
  if (
    typeof newNotification.id !== 'undefined' &&
    newNotification.id !== null
  ) {
    // // console.log('updating')
    url = `${url}${newNotification.id}`;
    options.method = 'put';
  }

  return simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        dispatch(handleApiError(json));
      } else {
        const preparedNotifications = normalize(json, {
          notification,
        });

        // // console.log(json)

        dispatch(
          receiveNotification(preparedNotifications.entities.notifications),
        );
      }
    });
};

export const actions = {
  requestNotification,
  receiveNotification,
  fetchNotification,
  saveNotification,
  deleteNotification,
  removeNotification,
  markNotificationAsRead,
  markAllNotificationsAsRead,
};

const NOTIFICATION_ACTION_HANDLERS = {
  [REQUEST_NOTIFICATION]: state => ({ ...state, fetching: true }),
  [REMOVE_NOTIFICATION]: (state, action) => ({
    ...state,
    notifications: _.omit(state.notifications, action.payload),
  }),
  [RECEIVE_NOTIFICATION]: (state, action) => {
    const stateNotifications = state.notifications;

    _.forOwn(action.payload.notifications, (_notification, id) => {
      const newNotification = _notification;

      if (typeof stateNotifications[id] === 'object') {
        Object.assign(
          stateNotifications[id],
          stateNotifications[id],
          newNotification,
        );
      } else {
        stateNotifications[id] = newNotification;
      }
    });

    return {
      ...state,
      notifications: stateNotifications,
      fetching: false,
    };
  },
};

// ------------------------------------
// Reducer
// ------------------------------------

export const initialState = {
  fetching: false,
  notifications: {},
};

export default function notificationReducer(state = initialState, action) {
  const handler = NOTIFICATION_ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/modules/notification.js